import React from 'react'

import { Helmet } from 'react-helmet'

import './bounty.css'

const Bounty = (props) => {
  return (
    <div className="bounty-container1">
      <Helmet>
        <title>bounty - guzuv says hi!</title>
        <meta
          name="description"
          content="hey, we got games and fun here at guzuv.ml!"
        />
        <meta property="og:title" content="bounty - guzuv says hi!" />
        <meta
          property="og:description"
          content="hey, we got games and fun here at guzuv.ml!"
        />
        <link
          rel="canonical"
          href="https://site-time-hv38k4.teleporthq.app/bounty"
        />
      </Helmet>
      <div className="bounty-thq-card-content-elm1">
        <h3 className="bounty-text10">mc bounty!</h3>
        <span className="bounty-text11">
          <span>
            objective: get diamond boots (have exactly 59 dirt beside it).
          </span>
          <br></br>
          <span>
            reward:
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span>35 Robux,</span>
          <span> or Minecoins!</span>
          <br></br>
          <span>expires in: 5/15/2023</span>
          <br></br>
          <span>SEND PROOF WITH &quot;want a game?&quot; button!</span>
          <br></br>
          <a
            href="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.9dZVX0M51h5mYVfjfDXh3AHaD1%26pid%3DApi&amp;f=1&amp;ipt=98df4859400b0c94967ebb3c678ebaad57caebb2790566fdd7cd0df70e6715e1&amp;ipo=images"
            target="_blank"
            rel="noreferrer noopener"
            className="bounty-link1"
          >
            how do i send proof?
          </a>
          <br></br>
          <span className="bounty-text23">
            SEND THE WHOLE SCREEN, INCLUDING GUZUV.GITHUB.IO!
          </span>
          <br></br>
        </span>
      </div>
      <div className="bounty-thq-card-content-elm2">
        <h3 className="bounty-text25 BigCard-Heading">mc bounty!</h3>
        <span className="bounty-text26">
          <span>
            objective: get a diamond pickaxe (have exactly 58 dirt beside it).
          </span>
          <br></br>
          <span>
            reward:
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="bounty-text30">30 Robux</span>
          <br></br>
          <span>expires in: 2/21/2023 (only half of prize now).</span>
          <br></br>
          <span>SEND PROOF WITH &quot;want a game?&quot; button!</span>
          <br></br>
          <a
            href="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.9dZVX0M51h5mYVfjfDXh3AHaD1%26pid%3DApi&amp;f=1&amp;ipt=98df4859400b0c94967ebb3c678ebaad57caebb2790566fdd7cd0df70e6715e1&amp;ipo=images"
            target="_blank"
            rel="noreferrer noopener"
            className="bounty-link2"
          >
            how do i send proof?
          </a>
          <br></br>
          <span className="bounty-text37">
            SEND THE WHOLE SCREEN, INCLUDING GUZUV.GITHUB.IO!
          </span>
          <br></br>
        </span>
      </div>
      <div className="bounty-thq-card-content-elm3">
        <h3 className="bounty-text39 BigCard-Heading">Bounty!</h3>
        <span className="bounty-text40">
          <span>objective: get 69 score in flappy bird!</span>
          <br></br>
          <span>reward: 25 Robux (not joking)</span>
          <br></br>
          <span>
            expires in: 9/1/2023! (claimed by @959922152600113152
            &quot;hazzor&quot;)
          </span>
          <br></br>
          <span>SEND PROOF WITH &quot;want a game?&quot; button!</span>
          <br></br>
          <a
            href="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.9dZVX0M51h5mYVfjfDXh3AHaD1%26pid%3DApi&amp;f=1&amp;ipt=98df4859400b0c94967ebb3c678ebaad57caebb2790566fdd7cd0df70e6715e1&amp;ipo=images"
            target="_blank"
            rel="noreferrer noopener"
            className="bounty-link3"
          >
            how do i send proof?
          </a>
          <br></br>
        </span>
      </div>
      <a href="https://play.teleporthq.io/signup" className="bounty-link4">
        <div aria-label="Sign up to TeleportHQ" className="bounty-container2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="bounty-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="bounty-text50">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Bounty
